import { render, staticRenderFns } from "./BaseNote.vue?vue&type=template&id=93744c42&scoped=true"
import script from "./BaseNote.vue?vue&type=script&lang=js"
export * from "./BaseNote.vue?vue&type=script&lang=js"
import style0 from "./BaseNote.vue?vue&type=style&index=0&id=93744c42&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93744c42",
  null
  
)

export default component.exports